import React from 'react'
import cx from 'classnames'
import styles from './SecondaryTab.module.scss'
import { Icon } from 'components/shared/Icon/Icon'
import { CautionSign } from 'components/shared/CautionSign/CautionSign'

type SecondaryTabProps = {
  id?: string
  icon?: React.ComponentProps<typeof Icon>['icon']
  label?: React.ReactNode
  isDisabled?: boolean
  isActiveTab?: boolean
  setActiveTab?: (id?: string) => void
  tabClassName?: string
  iconClassName?: string
  caution?: number
}

export const SecondaryTab = ({
  id,
  icon,
  label,
  isDisabled,
  isActiveTab,
  setActiveTab,
  tabClassName,
  iconClassName,
  caution = 0,
}: SecondaryTabProps) => {
  return (
    <button
      className={cx(styles.tab, tabClassName, {
        [styles.active]: isActiveTab,
        [styles.disabled]: isDisabled,
      })}
      key={id}
      {...(!isDisabled && { onClick: () => setActiveTab?.(id) })}
    >
      {icon ? (
        <Icon className={cx(styles.icon, iconClassName)} icon={icon} />
      ) : null}
      {label}
      <CautionSign count={caution} placement="bottom" />
    </button>
  )
}
